export default "<button (click)=\"clickAction($event)\" class=\"prev-button\" *ngIf=\"data\">\r\n  {{ data.title }}\r\n</button>\r\n";